import MarkdownEdit from "./edit"
import MarkdownView from "./view"
// import MarkdownBlockEdit from "./MarkdownEditor"

export default { view: MarkdownView, edit: MarkdownEdit }
